import { LOADER_SET } from '../actions/loaderAction';

export const loaderReducer = (state = false, action) => {
  switch (action.type) {
    case LOADER_SET:
      return action.data;
    default:
      return state;
  }
};